import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Tabs from '../SegmentBar/TabBar';
import './ReportedIssues.css';
import TableComponent from "../TableComponent/TableComponent.jsx";
import { fetchAnalyticsProd } from "../services/FirebaseService.js"; // Import the centralized function


function ReportedIssues() {
    const navigate = useNavigate();
    const [reportedIssuesData, setData] = useState([]); // State to hold the table data
    const location = useLocation(); // Get the current route
    const [activeIndex, setActiveIndex] = useState(2); // Default to "Reported Issues"

    useEffect(() => {
        const fetchData = async () => {
            try {
                const reportedIssuesData = await fetchAnalyticsProd("Reported Issues/PROD"); // Fetch data
                var sorted_data = reportedIssuesData.sort((a,b) => {
                    return new Date(a.timestamp).getTime() - 
                        new Date(b.timestamp).getTime()
                }).reverse();
                setData(sorted_data); // Update the state with the fetched data
            } catch (err) {
                console.error("Error fetching reported issues data:", err);
            }
        };
        fetchData();
        // Update the active index based on the current route
        if (location.pathname === "/user-feedbacks") {
            setActiveIndex(0);
        } else if (location.pathname === "/feature-requests") {
            setActiveIndex(1);
        } else if (location.pathname === "/reported-issues") {
            setActiveIndex(2);
        }
    }, [location.pathname]);

    const handleTabSelect = (index) => {
        console.log(`Selected Tab: ${index}`);
        const paths = ["/user-feedbacks", "/feature-requests", "/reported-issues"];
        setActiveIndex(index); // Update the active index
        if (index !== 2) {
            navigate(paths[index]); // Navigate to the selected route
        }
    };

    const columns = React.useMemo(
        () => [
            { Header: "Timestamp", accessor: "timestamp" },
            { Header: "Steps to Reproduce", accessor: "stepsToReproduce" },
            { Header: "Issue Description", accessor: "issue" },
            { Header: "DHU Firmware Version", accessor: "firmwareVersion" },
            { Header: "Device Serial Number", accessor: "dsn" },
            { Header: "Mobile App Version", accessor: "mobileAppVersion" },
            { Header: "Mobile Model", accessor: "mobileModel" },
            { Header: "Vehicle Model", accessor: "vehicleModel" },
            { Header: "Vehicle Serial", accessor: "vehicleSerial" },
            { Header: "User ID", accessor: "userId" },
        ],
        []
    );

    return (
        <div className="ReportedIssues">
            <div className="tab-container">
                <Tabs
                    tabs={["LDC Feedbacks", "Feature Requests", "Reported Issues"]}
                    onTabSelect={handleTabSelect}
                    activeIndex={activeIndex}
                />
            </div>
            <div className="feature-content">
            <div className="BodyReportedIssue">
                Reported Issues
            </div>
            </div>
            {reportedIssuesData.length === 0 ? (
                <div className="no-feedback-message">
                    No Reported Issues submitted by the users.
                </div>
            ) : (
                <TableComponent columns={columns} data={reportedIssuesData} />
            )}
            
        </div>
    );
}

export default ReportedIssues;